module.exports = __webpack_public_path__ + "img/co2.a228845.jpg";